import * as React from 'react'
import './Stats.scss'
import { ActionType, indexStatListItem, reducerStoreType, storeAmtItem, storeType } from "../../reducers/types";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { FormattedMessage } from "react-intl";
import Loadable from 'react-loadable';

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  list7day: indexStatListItem[],
  tradeAmtArea: storeAmtItem[],
  currency: string,
  storeList: storeType[],
  listMap: { [key: string]: indexStatListItem[] },
  tradeAmtAreaMap: { [key: string]: storeAmtItem[] }
}

interface IState {
}

const LoadableComponent = Loadable({
  loader: () => import('./DayTurnOverLine'),
  loading() { return (<div>loading...</div>) },
});

const LoadableComponentStore = Loadable({
  loader: () => import('./StoreTurnOverBar'),
  loading() { return (<div>loading...</div>) },
});

class Stats extends React.Component<IProps, IState> {
  public render() {
    const listMapKeys = Object.keys(this.props.listMap) || [];
    return (
      listMapKeys?.map((key, index) => (
        < Grid container item xs={12} className="Stats" spacing={2} key={index}>
          <Grid item xs={12} lg={6}>
            <div className="day-turnover">
              <h3><FormattedMessage id="turnOverLineTitle" />({key})</h3>
              <LoadableComponent list7day={this.props.listMap[key] || []} />
            </div>
          </Grid>
          <Grid item xs={12} lg={6}>
            <div className="store-turnover">
              <h3><FormattedMessage id="merchantStatsTitle" /></h3>
              <LoadableComponentStore storeList={this.props.storeList}
                tradeAmtArea={this.props.tradeAmtAreaMap[key] || []} />
            </div>
          </Grid>
        </Grid >
      ))
    );
  }
}

export default connect((state: reducerStoreType, props) => {
  return {
    list7day: state.dashboard.indexStat.list || [],
    tradeAmtArea: state.dashboard.indexStat.tradeAmtArea || [],
    currency: state.merchant.merchantInfo.currency,
    storeList: state.merchant.storeList || [],
    tradeAmtAreaMap: state.dashboard.indexStat.tradeAmtAreaMap || {},
    listMap: state.dashboard.indexStat.listMap || {},
  }
})(Stats)